import React from 'react';
import { connect } from 'react-redux';
import { compose, is } from 'ramda';

import styleFile from './PaymentPoints.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField';
import FormNotify from '@synergycms_core/components/generic/Form/FormNotify';
import { RichText, Image, Icon } from '@synergycms_core/components/generic';
import actions from '../../../../store/actions';
import { Map } from 'immutable';
import Price from '@synergycms_core/components/generic/Price';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider';
import AlertBlockPointsModal from '../../../functional/CustomerForm/AlertBlockPointsModal.jsx';
import { ESTABLISHMENT_TYPE_APARTMENT, ESTABLISHMENT_TYPE_HOTEL } from '../../../../store/hotels/hotelsActions';
import { parseTaxes, sumTaxAmounts, round } from '../../../../utils';

const STAR_TRAVELER_MIN_POINTS = 500;

class STPaymentPoints extends React.Component {
  static displayName = 'STPaymentPoints';

  constructor(props) {
    super(props);

    const { defaultValue = 0, reservation } = this.props.config;

    const loyaltyPoints = reservation.getIn(['payment', 'loyalty_points'], false);

    this.state = {
      value: loyaltyPoints || defaultValue
    };
  }

  toggleBlockPoints = (value, checkboxChange) => {
    const {toggleModal, refreshBlockPoints, deleteBlockPoints, allowLoyaltyPoints } = this.props.config;
    value = !allowLoyaltyPoints;
    if (value) {
      refreshBlockPoints().then((serverBlock) => {
        if(serverBlock.success === false) {
          toggleModal(true, "alertBlockPoints", <AlertBlockPointsModal checkboxChange={checkboxChange} closeModal={()=> toggleModal(false, "alertBlockPoints")} />);
        } else {
          checkboxChange(value);
        }
      });
    } else {
      deleteBlockPoints('not_cancel_booking').finally(()=>{
        checkboxChange(value);
      });
    }

  }


  render() {
    const {
      loyaltyUser,
      reservation,
      loyalty,
      showTaxes,
      hotel,
      summaryPriceBreakdown,
      allowLoyaltyPoints,
      hasAparmentTypeId
    } = this.props.config;
    const { classes } = this.props.theme.styles;

    if(!loyalty || !loyaltyUser) {
      return null;
    }

    const totalPointsPrice = reservation.getIn(['loyalty','total_points_price'], 0);
    const usedPoints = reservation.getIn(['loyalty','redeem_points'],0);
    const currentPoints = reservation.getIn(["loyalty","current_points"]);
    //Se comprueba si existe payment_points_status a parte de si el usuario tiene menos de 500 puntos porque una vez bloqueado los puntos nos puede devolver que tiene 0 puntos el cliente
    const allow = loyaltyUser.getIn(["points", "allow_redeem"], false) && ( loyaltyUser.getIn(["points", "total"],0) >= STAR_TRAVELER_MIN_POINTS || reservation.getIn(["loyalty","payment_points_status"], false) !== false);
    const currentTier = loyaltyUser.getIn(["tier","current"]);
    // GLOSARIO.md FCL-003 - en hoteles con summaryPriceBreakdown, reservation.total_price no incluye
    // la fee obligatoria ni el resto de impuestos no incluidos; hay que sumarlos, igual que hace
    // Cancelation.jsx (importe total unico, sin distinguir "pagar ahora"/"pagar en destino").
    const taxes = summaryPriceBreakdown ? parseTaxes(hotel, reservation) : null;
    const totalTaxesAmount = taxes ? round(sumTaxAmounts([...taxes.included, ...taxes.nonIncluded])) : 0;
    const totalPrice = summaryPriceBreakdown
      ? reservation.get('total_price', 0) + totalTaxesAmount
      : reservation.get(showTaxes ? 'total_price_tax' : 'total_price', 0);
    const pointsDiscount = totalPointsPrice || 0;
    const otherDiscounts = reservation.getIn(['payment', 'discount'], 0) + reservation.getIn(['payment', 'amount_promo_paid'], 0);
    const amountPending = totalPrice - pointsDiscount - otherDiscounts;
    const restPoints = currentPoints-usedPoints > 0 ? currentPoints-usedPoints : 0;
    //En algunos casos loyalty_user esta vacio, se comprueba si existe antes de mostrar el check de pago con puntos para evitar errores
    const showPaymentPoints = !hasAparmentTypeId && reservation.get('loyalty_user', false) && ( (usedPoints > 0 ) || (amountPending > 0) );
    //"accumulate_points"
    //"current_points"
    //"redeem_points"
    //"total_points_price"

    //const totalPricePoints = Math.trunc(reservation.get(showTaxes ? 'total_price_tax' : 'total_price') * reservation.get("redemption_ratio"));
      let Component;
    if(allow) {
      Component = (
        <div className={classes.inputRange}>
          {allowLoyaltyPoints ? (
            <>
              <div className={classes.paymentPointsBlock}>
                <div className={classes.starTravLogInLogo}>
                  <Image svg={currentTier === 'silver' ? 'stSilverLogo' : currentTier === 'gold' ? 'stGoldLogo' : 'stBlueLogo'} />
                </div>
                <div className={classes.paymentPointsInfoExtended}>
                  <div>
                    <RichText translate={true} ucFirst={true} text={'_%aplicado%_'} />: <Price amount={totalPointsPrice}/> <Icon innerStyle={[classes.checkIcon]} unicodeContent={'e046'} /><br />
                  </div>
                  <div>
                    <RichText text={usedPoints} />{' '}<RichText translate={true} text={'_%puntos Star Traveler%_'} /><br />
                  </div>
                  <div>
                    <RichText translate={true} ucFirst={true} text={'_%crédito restante%_'} />: <RichText translate={true} text={'_%{restPoints} puntos%_'} withVars={{ restPoints }} /><br />
                  </div>
                </div>
              </div>
              <div className={classes.paymentPointsError}>
                <FormNotify errors={(response) => {


                    if("NOT_ENOUGH_POINTS" === response.error) {
                      return "_%El cliente no tiene puntos suficientes%_";
                    }else if("TMS_REQUEST_ERROR" === response.error) {
                      return "_%Error de syn2 al intentar volcar reserva a tms%_";
                    } else if("TMS_GENERIC_ERROR"=== response.error){
                      return "_%Error generico de tms%_";
                    }
                  }}
                  />
              </div>
            </>
            ) : null
          }
        </div>
      );
    } else {
      Component = (
        <div className={classes.inputRange}>
          <RichText
            innerStyle={['roboto16BlackModified2']}
            translate={true}
            ucFirst={true}
            text={'_%para canjear puntos se requiere un mínimo de 500, sigue acumulando con tus reservas para poder usarlos pronto%_'}
          />
        </div>
      );
    }

    return (
      showPaymentPoints && <>
        <div className={classes.paymentPointsContainer}>
          <label>
            <div className={classes.relativeFoldContainer}>
              <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                        translate={true}>
                _%pagar con puntos Star Traveler%_
              </RichText>

              {allow && (
                <label className={classes.checkBox}>
                  <CheckboxField
                    beforeChange={this.toggleBlockPoints}
                    defaultValue={allowLoyaltyPoints}
                    type={'checkbox'}
                    model={'allow_loyalty_point_redemption'}
                    innerStyle={['inputCheck', classes.inputCheck]}
                    tier={currentTier}
                    serverValue={allowLoyaltyPoints && totalPointsPrice}
                    id={ !allowLoyaltyPoints ? 'td-points-check-00' : 'td-points-check-01' }
                  />
                </label>
              )}
            </div>

            <div className={allow ? [!allowLoyaltyPoints ? classes.hiddenPaymentPoints : ''].join(' ') : ''}>
              <div className={[classes.paymentPointsInfo, !allow ? classes.reducePadding : ''].join(' ')}>
                {Component}
              </div>
            </div>
          </label>
        </div>

        {allow && allowLoyaltyPoints && amountPending > 0 && (
          <div className={classes.paymentPointsContainerRemaining}>
            <RichText
              innerStyle={[classes.amountPendingText]}
              translate={true}
              ucFirst={true}
              text={'_%importe pendiente de pago%_'}
            />
            <Price
              amount={amountPending}
              innerStyle={[classes.amountPendingPrice]}
            />
          </div>
        )}
      </>
    );
  }
};

const mapDispatchToProps = (dispatch) => {

  return {
    refreshBlockPoints: () => {
      return dispatch(actions.customer.loyalty.refreshBlockPointsAsync());
    },
    deleteBlockPoints : (additionalInfo) => {
      return dispatch(actions.customer.loyalty.deleteBlockPointsAsync(additionalInfo));
    },
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const reservation = store.getIn(['customer', 'reservation']);
  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;

  return {
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data','loyalty'], null),
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    model: 'applied_points',
    showTaxes: hotel.get('show_taxes'),
    hotel,
    // GLOSARIO.md FCL-003
    summaryPriceBreakdown: hotel.get('summary_price_breakdown', false),
    trackingId : store.getIn(['customer', 'reservation', 'tracking_id'], null),
    allowLoyaltyPoints : reservation.getIn(['customer', 'allow_loyalty_point_redemption'], false),
    //Si no encuentra establishment_type_id por defecto pondremos que es de type_hotel = 2
    //hasAparmentTypeId : hotel.get('establishment_type_id', ESTABLISHMENT_TYPE_HOTEL) === ESTABLISHMENT_TYPE_APARTMENT,
    //Todos los hoteles ya que tengan ST activo tendran pago puntos
    hasAparmentTypeId : [].includes(hotelId),
    //hasAparmentTypeId : true
  };
};



export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  showPopover,
  PropertyManager([
    'reservation',
    'loyaltyUser',
    'loyalty',
    'form',
    'model',
    'showTaxes',
    'hotel',
    'summaryPriceBreakdown',
    'closeByFamily',
    'allowLoyaltyPoints',
    'hasAparmentTypeId',
    'toggleModal',
    'trackingId',
    'refreshBlockPoints',
    'deleteBlockPoints'
  ]),
  withThemeJSS({ styleFile, link: true })
)(STPaymentPoints);
